import axios from "axios";
import { API_BASE_URL } from "src/services/const";
import { beginRequest, endRequest } from "src/services/requestActivity";

const authInstance = axios.create({
  baseURL: API_BASE_URL
});

authInstance.interceptors.request.use(function (config) {
  beginRequest();
  let token = sessionStorage.getItem("token");

  config.headers["Authorization"] = "Bearer " + token;
  return config;
});

authInstance.interceptors.response.use(
  (response) => {
    endRequest();
    return response;
  },
  (error) => {
    endRequest();
    return Promise.reject(error);
  }
);

export default authInstance;
